import original from './data2';
import expansion from './expansion';
import expansion2 from './expansion2';
import adultExpansion from './adultExpansion';

export const contentVersion = 'adult-deck-v3';
// These original cards are ordinary opinions or mild party confessions.
const mildOriginalIds = new Set([13, 28, 43, 44, 48, 54, 58, 64, 65, 95, 112, 128, 129, 149, 152, 162, 165, 170, 172, 173, 175, 177, 178, 181, 182, 191, 195]);
const ratedOriginals = original.map(card => mildOriginalIds.has(card.id) ? { ...card, explicit: false } : card);

export const packInfo = [
  { id: 'new friends', name: 'Icebreakers', detail: 'New faces. Fast friends.', icon: 'spark', color: 'lime' },
  { id: 'old friends', name: 'The group chat', detail: 'For people who know too much.', icon: 'people', color: 'purple' },
  { id: 'hot takes', name: 'Hot takes', detail: 'Harmless opinions. Serious debate.', icon: 'sun', color: 'peach' },
  { id: 'family', name: 'Family table', detail: 'All ages. All personalities.', icon: 'home', color: 'blue' },
  { id: 'new couples', name: 'New couples', detail: 'Date night. First sparks, fresh discoveries.', icon: 'heart', color: 'pink' },
  { id: 'old couples', name: 'Established couples', detail: 'Date night. Shared history, new surprises.', icon: 'infinity', color: 'yellow' },
];
const seen = new Set();
export const allPrompts = [...adultExpansion, ...expansion2, ...expansion, ...ratedOriginals].filter(card => {
  const key = card.description.toLowerCase().replace(/[^a-z0-9]/g, '');
  if (seen.has(key)) return false;
  seen.add(key);
  return true;
});
export const newPromptCount = allPrompts.filter(card => card.fresh).length;
export const newSpicyPromptCount = allPrompts.filter(card => card.fresh && card.explicit).length;
export const newRegularPromptCount = newPromptCount - newSpicyPromptCount;
export const promptsById = new Map(allPrompts.map(card => [card.id, card]));
export const defaultSettings = { packs: ['new friends', 'old friends', 'hot takes'], spicy: false, length: 20, players: '', gesture: 'drink' };
export const getPool = settings => allPrompts.filter(card => settings.packs.includes(card.type) && (settings.spicy || !card.explicit));

export function shuffle(items, random = Math.random) {
  const result = [...items];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

export function getDeckSize(settings, pool = getPool(settings)) {
  return Math.min(settings.length, pool.length);
}

export function makeDeck(settings, played = {}) {
  const pool = getPool(settings);
  const history = Array.isArray(played) ? Object.fromEntries(played.map((id, i) => [id, i + 1])) : played;
  const rank = card => Number(history[card.id]) || 0;
  // Unseen cards tie at zero. After that, deal least-recently-played first.
  // Spice cadence is a preference, never a reason to repeat ahead of an unseen card.
  const prioritize = cards => shuffle(cards).sort((a, b) => rank(a) - rank(b));
  const regular = prioritize(pool.filter(card => !card.explicit));
  const spicy = prioritize(pool.filter(card => card.explicit));
  const useSpice = settings.spicy && spicy.length > 0;
  return Array.from({ length: getDeckSize(settings, pool) }, (_, index) => {
    if (!regular.length) return spicy.shift();
    if (!spicy.length) return regular.shift();
    const regularRank = rank(regular[0]), spicyRank = rank(spicy[0]);
    const spicySlot = useSpice && (index + 1) % 3 === 0;
    return (spicyRank < regularRank || (spicyRank === regularRank && spicySlot) ? spicy : regular).shift();
  });
}

export function getPair(names, index) {
  if (names.length < 2) return [];
  const pairs = [];
  for (let i = 0; i < names.length; i++) {
    for (let j = i + 1; j < names.length; j++) pairs.push([names[i], names[j]]);
  }
  return pairs[index % pairs.length];
}

export function readSaved(key, fallback) {
  try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; }
}
export function save(key, value) {
  if(key==='diyt-session-v2')window.RecessHistory?.record('drink-if-you-think',value);
  try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* Play still works when device storage is unavailable. */ }
}
